export const Countrycode = [
    {
        "name": "Ethiopia",
        "dial_code": "+251",
        "code": "ET"
    },
];